import InfoCallCenter from './InfoCallCenter';

export default InfoCallCenter;
